import {
  Alert,
  Autocomplete,
  Card,
  Chip,
  CircularProgress,
  Grid,
  Icon,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDAuditModal from "components/MDAuditModal";
import { useMaterialUIController } from "context";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import { useEffect, useState } from "react";
import { errorAlert, successAlert } from "utils/Functions";
import { get, post, postNoResponse } from "utils/WebService";
import { ESCURO } from "assets/coresTema";

const PASTAS_SISTEMA = [
  {
    chave: "PATH_REMESSAS",
    descricao: "Remessas Bancárias - Bradesco",
    finalidade: "Arquivos de remessa (.REM) gerados para o Bradesco (subpastas por ano/mês)",
    defaultPath: "\\\\servidor\\ADM COBRANÇA\\BRADESCO\\CNAB-Envio",
    icon: "upload_file",
    color: "info",
  },
  {
    chave: "PATH_RETORNOS",
    descricao: "Retornos Bancários - Bradesco",
    finalidade: "Cópia dos arquivos de retorno (.RET) do Bradesco importados",
    defaultPath: "D:\\Cobranca\\Retornos\\",
    icon: "download_for_offline",
    color: "success",
  },
  {
    chave: "PATH_CNAB_PAGAMENTOS",
    descricao: "Relatórios de Pagamentos CNAB - Bradesco",
    finalidade: "Relatórios PDF de baixas e pagamentos do retorno do Bradesco",
    defaultPath: "\\\\servidor\\ADM COBRANÇA\\BRADESCO\\Pagamentos_Efetuados",
    icon: "picture_as_pdf",
    color: "error",
  },
  {
    chave: "PATH_REMESSAS_ITAU",
    descricao: "Remessas Bancárias - Itaú",
    finalidade: "Arquivos de remessa (.REM) gerados para o Itaú (subpastas por ano/mês). Em branco: subpasta ITAU da pasta do Bradesco",
    defaultPath: "\\\\servidor\\ADM COBRANÇA\\ITAU\\CNAB-Envio",
    icon: "upload_file",
    color: "info",
  },
  {
    chave: "PATH_RETORNOS_ITAU",
    descricao: "Retornos Bancários - Itaú",
    finalidade: "Cópia dos arquivos de retorno (.RET) do Itaú importados. Em branco: subpasta ITAU da pasta do Bradesco",
    defaultPath: "\\\\servidor\\ADM COBRANÇA\\ITAU\\Retornos",
    icon: "download_for_offline",
    color: "success",
  },
  {
    chave: "PATH_CNAB_PAGAMENTOS_ITAU",
    descricao: "Relatórios de Pagamentos CNAB - Itaú",
    finalidade: "Relatórios PDF de baixas e pagamentos do retorno do Itaú. Em branco: subpasta ITAU da pasta do Bradesco",
    defaultPath: "\\\\servidor\\ADM COBRANÇA\\ITAU\\Pagamentos_Efetuados",
    icon: "picture_as_pdf",
    color: "error",
  },
  {
    chave: "PATH_DOCUMENTOS",
    descricao: "Documentos do Sistema",
    finalidade: "Documentos de fichas de devedores e processos jurídicos",
    defaultPath: "D:\\Cobranca\\Documentos\\",
    icon: "description",
    color: "primary",
  },
  {
    chave: "PATH_IMPORTACAO",
    descricao: "Importações",
    finalidade: "Planilhas e arquivos para cargas e importações",
    defaultPath: "D:\\Cobranca\\Importacao\\",
    icon: "drive_folder_upload",
    color: "secondary",
  },
  {
    chave: "PATH_GRAVACOES",
    descricao: "Gravações de Telefonia",
    finalidade: "Gravações das chamadas telefônicas (Nextbilling)",
    defaultPath: "D:\\Cobranca\\Gravacoes\\",
    icon: "record_voice_over",
    color: "warning",
  },
  {
    chave: "PATH_RELATORIOS",
    descricao: "Templates de Relatórios",
    finalidade: "Templates de relatórios customizados (Cobrança e Jurídico)",
    defaultPath: "D:\\Cobranca\\Relatorios\\",
    icon: "assessment",
    color: "info",
  },
  {
    chave: "PATH_EXPORTACAO_COMPARADOR_PROCESSOS",
    descricao: "Exportação Comparador de Processos",
    finalidade: "Diretório para salvar a planilha de processos não localizados para o robô",
    defaultPath: "D:\\Cobranca\\ComparadorProcessos\\",
    icon: "find_replace",
    color: "warning",
  },
];

// Aba "Regras de Processamento": parâmetros numéricos lidos pelo backend
const REGRAS_PROCESSAMENTO = [
  {
    chave: "SOLICITACAO_INTERVALO_COBRANCA_HORAS",
    descricao: "Fila de Solicitações: intervalo entre cobranças",
    finalidade:
      "Depois de recusar uma devolução ou migração, o suporte pode cobrar a posição do solicitante (ciente ou reenviar) a cada este número de horas, contado da recusa ou da última cobrança",
    unidade: "horas",
    defaultVal: "24",
    minimo: 1,
    icon: "notifications_active",
    color: "warning",
  },
];

const PARAMETROS_EMAILS_ROBOS = [
  {
    chave: "ROBO_EMAIL_TESTE",
    label: "E-mail de Teste (Produção)",
    detalhe: "Quando preenchido, os robôs de produção enviam TODOS os e-mails só para este endereço (teste controlado). Deixe vazio para o envio normal. Em desenvolvimento vale o e-mail de Validação.",
    placeholder: "Ex: marcos.andrade@raadvogados.adv.br",
    icon: "mark_email_read",
    color: "#FFA726",
    sm: 6,
  },
  {
    chave: "ROBO_EMAIL_NAO_LOCALIZADOS",
    label: "E-mail - Processos Não Localizados",
    detalhe: "Destinatários para processos que não forem encontrados na base de dados do Wibs.",
    placeholder: "Ex: socios@raadvogados.adv.br, aline@rbombonato.com",
    icon: "search_off",
    color: "#EF5350",
    sm: 6,
  },
  {
    chave: "ROBO_EMAIL_OUTROS",
    label: "E-mail - Outros (Fallback Geral de Equipes)",
    detalhe: "Destinatários de fallback quando uma equipe não tiver e-mail específico configurado.",
    placeholder: "Ex: socios@raadvogados.adv.br, aline@rbombonato.com",
    icon: "alternate_email",
    color: "#42A5F5",
    sm: 6,
  },
  {
    chave: "ROBO_EMAIL_VALIDACAO",
    label: "E-mail - Validação / Relatório de Erros",
    detalhe: "Destinatários de validação técnica e alertas de erros dos robôs. Em desenvolvimento (robô sem o arquivo prd), TODOS os e-mails dos robôs vão só para este endereço.",
    placeholder: "Ex: aline@rbombonato.com",
    icon: "verified_user",
    color: "#66BB6A",
    sm: 6,
  },
  {
    chave: "ROBO_MONITOR_EMAILS_ALERTA",
    label: "E-mail - Alertas do Monitor de Robôs",
    detalhe: "Recebe um aviso quando um robô dá erro, atrasa ou trava e quando o serviço dos robôs para, e outro quando normaliza (Robôs > Monitor de Robôs). Vazio = sem alerta. Só em produção.",
    placeholder: "Ex: ti@raadvogados.adv.br, aline@rbombonato.com",
    icon: "notifications_active",
    color: "#FFA726",
    sm: 6,
  },
];

const EQUIPES_WIBS = [
  { chave: "RAL-Cível 01", rotulo: "RAL-Cível 01 (Cível 01)" },
  { chave: "RAL-Cível 02", rotulo: "RAL-Cível 02 (Cível 02)" },
  { chave: "RAL-Cível 03", rotulo: "RAL-Cível 03 (Cível 03)" },
  { chave: "RAL-Cível 04", rotulo: "RAL-Cível 04 (Cível 04)" },
  { chave: "RAL-Cível 05", rotulo: "RAL-Cível 05 (Cível 05)" },
  { chave: "RAL-Cível 06", rotulo: "RAL-Cível 06 (Cível 06)" },
  { chave: "RAL-Cível 07", rotulo: "RAL-Cível 07 (Cível 07)" },
  { chave: "RAL-Cível 08", rotulo: "RAL-Cível 08 (Cível 08)" },
  { chave: "RAL-Consultivo 01", rotulo: "RAL-Consultivo 01 (Consultivo 01)" },
  { chave: "RAL-Trabalhista 01", rotulo: "RAL-Trabalhista 01 (Trabalhista 01)" },
];

const ROBOS_STATUS = [
  {
    chave: "ROBO_EPROC_HABILITADO",
    nome: "Robô EPROC - Execução Habilitada",
    descricao: "Robô EPROC - Execução Habilitada",
    detalhe: "Varredura e leitura de processos EPROC e comparativo WIBS",
    defaultVal: "true",
  },
  {
    chave: "ROBO_TLEGAL_HABILITADO",
    nome: "Robô T-Legal - Execução Habilitada",
    descricao: "Robô T-Legal - Execução Habilitada",
    detalhe: "Leitura do relatório de publicações T-Legal (.doc ou .docx), consulta ao WIBS e comparativo com os Recortes do dia e do dia útil anterior (mesmo fluxo do EPROC)",
    defaultVal: "false",
  },
  {
    chave: "ROBO_RECORTES_HABILITADO",
    nome: "Robô Recortes (WIBS / AASP) - Execução Habilitada",
    descricao: "Robô Recortes (WIBS / AASP) - Execução Habilitada",
    detalhe: "Leitura de planilhas de recortes AASP e processamento de publicações",
    defaultVal: "true",
  },
  {
    chave: "ROBO_EMAILS_PUSH_HABILITADO",
    nome: "Robô E-mails Push - Execução Habilitada",
    descricao: "Robô E-mails Push - Execução Habilitada",
    detalhe: "Processamento de notificações e e-mails push de tribunais",
    defaultVal: "true",
  },
  {
    chave: "ROBO_INTIMACAO_HABILITADO",
    nome: "Robô Intimação - Execução Habilitada",
    descricao: "Robô Intimação - Execução Habilitada",
    detalhe: "Captura e triagem de intimações judiciais eletrônicas",
    defaultVal: "true",
  },
  {
    chave: "ROBO_TRT_HABILITADO",
    nome: "Robô TRT - Execução Habilitada",
    descricao: "Robô TRT - Execução Habilitada",
    detalhe: "Varredura de processos na Justiça do Trabalho (TRT Geral)",
    defaultVal: "false",
  },
  {
    chave: "ROBO_TRT2_HABILITADO",
    nome: "Robô TRT2 - Execução Habilitada",
    descricao: "Robô TRT2 - Execução Habilitada",
    detalhe: "Varredura de processos no TRT 2ª Região (SP)",
    defaultVal: "false",
  },
  {
    chave: "ROBO_PJE_HABILITADO",
    nome: "Robô PJE - Execução Habilitada",
    descricao: "Robô PJE - Execução Habilitada",
    detalhe: "Consulta e andamentos em sistemas PJE",
    defaultVal: "false",
  },
  {
    chave: "ROBO_PROJUDI_HABILITADO",
    nome: "Robô PROJUDI - Execução Habilitada",
    descricao: "Robô PROJUDI - Execução Habilitada",
    detalhe: "Integração e consulta aos processos do PROJUDI",
    defaultVal: "false",
  },
  {
    chave: "ROBO_ESAJ_HABILITADO",
    nome: "Robô ESAJ - Execução Habilitada",
    descricao: "Robô ESAJ - Execução Habilitada",
    detalhe: "Consulta de processos no portal e-SAJ dos tribunais estaduais",
    defaultVal: "false",
  },
  {
    chave: "ROBO_OAB_HABILITADO",
    nome: "Robô OAB - Execução Habilitada",
    descricao: "Robô OAB - Execução Habilitada",
    detalhe: "Monitoramento e captura de publicações por OAB",
    defaultVal: "false",
  },
  {
    chave: "ROBO_MNI_HABILITADO",
    nome: "Robô MNI - Execução Habilitada",
    descricao: "Robô MNI - Execução Habilitada",
    detalhe: "Integração via Modelo Nacional de Interoperabilidade (MNI)",
    defaultVal: "false",
  },
  {
    chave: "ROBO_TELEFONICA_HABILITADO",
    nome: "Robô Telefônica - Execução Habilitada",
    descricao: "Robô Telefônica - Execução Habilitada",
    detalhe: "Integração de dados e processos do portal Telefônica / Vivo",
    defaultVal: "false",
  },
  {
    chave: "ROBO_SCANIA_HABILITADO",
    nome: "Robô Scania - Execução Habilitada",
    descricao: "Robô Scania - Execução Habilitada",
    detalhe: "Integração de processos e batimento de cobrança Scania",
    defaultVal: "false",
  },
  {
    chave: "ROBO_EDITAL_HABILITADO",
    nome: "Robô Edital - Execução Habilitada",
    descricao: "Robô Edital - Execução Habilitada",
    detalhe: "Busca de editais e publicações em diários de justiça",
    defaultVal: "false",
  },
  {
    chave: "ROBO_BCB_HABILITADO",
    nome: "Robô BCB - Execução Habilitada",
    descricao: "Robô BCB - Execução Habilitada",
    detalhe: "Consultas de índices e taxas no Banco Central do Brasil",
    defaultVal: "false",
  },
  {
    chave: "ROBO_MONITOR_TELA_HABILITADA",
    nome: "Monitor de Robôs - Tela da máquina",
    descricao: "Monitor de Robôs: fotografa a tela da máquina enquanto um robô trabalha",
    detalhe: "Enquanto um robô trabalha, a tela da máquina dos robôs é fotografada a cada 4 s e aparece ao vivo no detalhe do robô (Robôs > Monitor de Robôs); na execução com erro, a última foto fica nos arquivos dela. Desligue se a máquina também for usada por pessoas.",
    defaultVal: "true",
  },
];

const PASTAS_E_CONFIG_ROBOS = [
  {
    chave: "ROBO_EPROC_PASTA_ENTRADA",
    descricao: "Robô EPROC - Pasta de Entrada",
    finalidade: "Diretório de entrada onde o robô EPROC lê as planilhas de processos (.xls/.xlsx)",
    defaultPath: "C:\\Gravitao\\Eproc\\",
    icon: "folder",
    color: "info",
    isFolder: true,
  },
  {
    chave: "ROBO_EPROC_PASTA_HISTORICO",
    descricao: "Robô EPROC - Pasta de Histórico",
    finalidade: "Diretório para onde as planilhas EPROC são movidas após o processamento",
    defaultPath: "C:\\Gravitao\\Eproc\\Historico\\",
    icon: "folder_special",
    color: "secondary",
    isFolder: true,
  },
  {
    chave: "ROBO_EPROC_PASTA_ARQUIVOS_WIBS",
    descricao: "Robô EPROC - Pasta dos Arquivos do WIBS",
    finalidade: "Cópias do que subiu no WIBS (UPLOAD_...csv) e do retorno do WIBS (RETORNO_WIBS_...txt), separadas dos arquivos reais. Vazio: subpasta Arquivos_WIBS da pasta de histórico",
    defaultPath: "",
    exemplo: "C:\\Gravitao\\Eproc\\Historico\\Arquivos_WIBS\\",
    icon: "cloud_sync",
    color: "secondary",
    isFolder: true,
  },
  {
    chave: "ROBO_EPROC_PASTA_RECORTES",
    descricao: "Robô EPROC - Pasta de Recortes (Comparativo)",
    finalidade: "Pasta adicional onde o robô EPROC procura o arquivo de Recortes da mesma data (além da pasta de histórico do Robô Recortes)",
    defaultPath: "C:\\Gravitao\\Recortes\\",
    icon: "folder_copy",
    color: "info",
    isFolder: true,
  },
  {
    chave: "ROBO_EPROC_EMAILS_DESTINO",
    descricao: "Robô EPROC - E-mails do Dashboard e Avisos",
    finalidade: "Destinatários do Dashboard EPROC e dos avisos de arquivo não processado por falta de Recortes (os e-mails por equipe vêm do cadastro de Equipes)",
    defaultPath: "socios@raadvogados.adv.br, veronica.jancanti@raadvogados.adv.br, ti@raadvogados.adv.br",
    icon: "email",
    color: "warning",
    isFolder: false,
  },
  {
    chave: "ROBO_TLEGAL_PASTA_ENTRADA",
    descricao: "Robô T-Legal - Pasta de Entrada",
    finalidade: "Diretório onde o robô T-Legal lê o relatório de publicações (.docx). A data do nome do arquivo define o Recortes usado no comparativo",
    defaultPath: "C:\\Gravitao\\TLegal\\",
    icon: "folder",
    color: "info",
    isFolder: true,
  },
  {
    chave: "ROBO_TLEGAL_PASTA_HISTORICO",
    descricao: "Robô T-Legal - Pasta de Histórico",
    finalidade: "Diretório para onde os arquivos T-Legal são movidos após o processamento (não use uma pasta de Recortes)",
    defaultPath: "C:\\Gravitao\\TLegal\\Historico\\",
    icon: "folder_special",
    color: "secondary",
    isFolder: true,
  },
  {
    chave: "ROBO_TLEGAL_PASTA_ARQUIVOS_WIBS",
    descricao: "Robô T-Legal - Pasta dos Arquivos do WIBS",
    finalidade: "Cópias do que subiu no WIBS (UPLOAD_...csv) e do retorno do WIBS (RETORNO_WIBS_...txt), separadas dos arquivos reais. Vazio: subpasta Arquivos_WIBS da pasta de histórico",
    defaultPath: "",
    exemplo: "C:\\Gravitao\\TLegal\\Historico\\Arquivos_WIBS\\",
    icon: "cloud_sync",
    color: "secondary",
    isFolder: true,
  },
  {
    chave: "ROBO_TLEGAL_EMAILS_DESTINO",
    descricao: "Robô T-Legal - E-mails do Dashboard e Avisos",
    finalidade: "Destinatários do Dashboard T-Legal e dos avisos de arquivo não processado por falta de Recortes. Os e-mails por equipe são os mesmos do EPROC (campo \"E-mail Robô EPROC / T-Legal\" no cadastro de Equipes)",
    defaultPath: "socios@raadvogados.adv.br, veronica.jancanti@raadvogados.adv.br, ti@raadvogados.adv.br",
    icon: "email",
    color: "warning",
    isFolder: false,
  },
  {
    chave: "ROBO_RECORTES_PASTA_ENTRADA",
    descricao: "Robô Recortes - Pasta de Entrada (AASP)",
    finalidade: "Diretório de leitura dos arquivos diários de recortes AASP",
    defaultPath: "\\\\servidor\\CIVEL\\AASP\\",
    icon: "folder",
    color: "info",
    isFolder: true,
  },
  {
    chave: "ROBO_RECORTES_PASTA_HISTORICO",
    descricao: "Robô Recortes - Pasta de Histórico (Processados)",
    finalidade: "Diretório onde ficam os arquivos de recortes processados (lidos pelo Robô EPROC para comparativo seguro)",
    defaultPath: "\\\\servidor\\CIVEL\\AASP\\processado\\",
    icon: "folder_special",
    color: "secondary",
    isFolder: true,
  },
  {
    chave: "ROBO_RECORTES_PASTA_ARQUIVOS_WIBS",
    descricao: "Robô Recortes - Pasta dos Arquivos do WIBS",
    finalidade: "Cópias do que subiu no WIBS (UPLOAD_...csv) e do retorno do WIBS (RETORNO_WIBS_...txt), separadas dos Recortes reais. Vazio: subpasta Arquivos_WIBS da pasta de histórico (o comparativo do EPROC e do T-Legal não lê subpastas)",
    defaultPath: "",
    exemplo: "\\\\servidor\\CIVEL\\AASP\\processado\\Arquivos_WIBS\\",
    icon: "cloud_sync",
    color: "secondary",
    isFolder: true,
  },
  {
    chave: "ROBO_RECORTES_EMAILS_DESTINO",
    descricao: "Robô Recortes - E-mails do Dashboard",
    finalidade: "Destinatários do Dashboard de Recortes: conferência entre o arquivo lido, o lançamento no WIBS e o envio às equipes (os e-mails por equipe vêm do cadastro de Equipes)",
    defaultPath: "socios@raadvogados.adv.br, veronica.jancanti@raadvogados.adv.br, paralegal@raadvogados.adv.br, marcos.andrade@raadvogados.adv.br, rafael.lainetti@raadvogados.adv.br, suporte.ral@raadvogados.adv.br",
    icon: "email",
    color: "warning",
    isFolder: false,
  },
];

const PROCESSOS_SISTEMA = [
  {
    chave: "OCORRENCIA_IMPORTACAO_REMESSA",
    descricao: "Importação de Remessa / Base de Dados",
    defaultText: "Ocorrência lançada quando uma ficha é importada via remessa",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_BATIMENTO",
    descricao: "Devolução de Ficha no Batimento",
    defaultText:
      "Ocorrência lançada quando a ficha inteira é devolvida por ausência na remessa",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_FICHA",
    descricao: "Devolução de Ficha (Operacional / Suporte)",
    defaultText:
      "Ocorrência lançada quando a ficha inteira é devolvida pelo usuário (Base de Dados) ou via Fila de Suporte",
  },
  {
    chave: "OCORRENCIA_SOLICITACAO_DEVOLUCAO_FICHA",
    descricao: "Solicitação de Devolução de Ficha",
    defaultText:
      "Ocorrência lançada quando o usuário pede a devolução da ficha à Fila de Solicitações (o anexo do pedido fica nela). Sem vínculo: \"Solicitação de Devolução de Ficha pendente\"",
  },
  {
    chave: "OCORRENCIA_REATIVACAO_FICHA",
    descricao: "Reativação de Ficha",
    defaultText:
      "Ocorrência lançada na reativação manual de uma ficha devolvida",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_CONTRATO_BATIMENTO",
    descricao: "Devolução de Contrato / Dívida no Batimento",
    defaultText:
      "Ocorrência lançada quando um contrato/dívida é devolvido por ausência na remessa",
  },
  {
    chave: "OCORRENCIA_DEVOLUCAO_CONTRATO",
    descricao: "Devolução de Contrato (Operacional / Suporte)",
    defaultText:
      "Ocorrência lançada quando um contrato/dívida é devolvido pelo usuário (Base de Dados) ou via Fila de Suporte",
  },
  {
    chave: "OCORRENCIA_SOLICITACAO_DEVOLUCAO_CONTRATO",
    descricao: "Solicitação de Devolução de Contrato",
    defaultText:
      "Ocorrência lançada quando o usuário pede a devolução de contratos à Fila de Solicitações (o anexo do pedido fica nela). Sem vínculo: \"Solicitação de Devolução de Débito pendente\"",
  },
  {
    chave: "OCORRENCIA_REATIVACAO_CONTRATO",
    descricao: "Reativação de Contrato / Dívida",
    defaultText:
      "Ocorrência lançada na reativação de um contrato previamente devolvido",
  },
  {
    chave: "OCORRENCIA_SOLICITACAO_MIGRACAO_CARTEIRA",
    descricao: "Solicitação de Migração de Carteira",
    defaultText:
      "Ocorrência lançada quando o usuário pede a migração de carteira à Fila de Solicitações (o anexo do pedido fica nela)",
  },
  {
    chave: "OCORRENCIA_EFETIVACAO_MIGRACAO_CARTEIRA",
    descricao: "Migração de Carteira (Efetivada / Aprovada)",
    defaultText:
      "Ocorrência lançada quando a migração de carteira é efetivada ou aprovada pelo suporte",
  },
  {
    chave: "OCORRENCIA_ALTERACAO_CADASTRAL",
    descricao: "Alteração Cadastral (Endereço / Telefone / E-mail)",
    defaultText:
      "Ocorrência lançada na atualização de dados de contato do devedor",
  },
  {
    chave: "OCORRENCIA_ATUALIZACAO_DEBITO",
    descricao: "Atualização de Débito / Contrato na Importação",
    defaultText:
      "Ocorrência lançada quando o saldo ou valor do contrato é atualizado no batimento/importação",
  },
  {
    chave: "OCORRENCIA_EXCLUSAO_CADASTRAL",
    descricao: "Exclusão de Dados Cadastrais",
    defaultText:
      "Ocorrência lançada na exclusão de endereços, telefones ou e-mails do devedor",
  },
  {
    chave: "OCORRENCIA_EXCLUSAO_CONTRATO",
    descricao: "Exclusão de Contrato",
    defaultText: "Ocorrência lançada na exclusão de um contrato da ficha",
  },
  {
    chave: "OCORRENCIA_FORMALIZACAO_ACORDO",
    descricao: "Formalização de Acordo",
    defaultText: "Ocorrência lançada no fechamento e formalização de um acordo",
  },
  {
    chave: "OCORRENCIA_CANCELAMENTO_ACORDO",
    descricao: "Cancelamento de Acordo",
    defaultText:
      "Ocorrência lançada quando um acordo é cancelado (manualmente ou por uma nova formalização), com quem cancelou e como estava o acordo. Sem vínculo: \"ACORDO CANCELADO\"",
  },
  {
    chave: "OCORRENCIA_BAIXA_PAGAMENTO",
    descricao: "Pagamento de Parcela de Acordo",
    defaultText:
      "Ocorrência lançada no pagamento de parcela intermediária de acordo",
  },
  {
    chave: "OCORRENCIA_EMISSAO_BOLETO",
    descricao: "Emissão / Reemissão de Boleto de Parcela",
    defaultText:
      "Ocorrência lançada ao emitir o boleto de uma parcela ou reemiti-lo com outro vencimento (o anterior é cancelado). Sem vínculo: \"Emissão de Boleto\"",
  },
  {
    chave: "OCORRENCIA_ALTERACAO_VENCIMENTO_PARCELA",
    descricao: "Alteração de Vencimento de Parcela",
    defaultText:
      "Ocorrência lançada ao trocar o vencimento de uma parcela do acordo. Sem vínculo: \"ALTERAÇÃO DE VENCIMENTO DE PARCELA\"",
  },
  {
    chave: "OCORRENCIA_QUITACAO_ACORDO",
    descricao: "Quitação de Acordo (Última Parcela)",
    defaultText:
      "Ocorrência lançada no pagamento da última parcela e quitação do acordo",
  },
  {
    chave: "OCORRENCIA_ENVIO_CNAB",
    descricao: "Geração / Envio de Remessa CNAB",
    defaultText:
      "Ocorrência lançada na geração e disparo de remessa bancária CNAB",
  },
  {
    chave: "OCORRENCIA_IMPORTACAO_CNAB",
    descricao: "Processamento de Retorno CNAB",
    defaultText:
      "Ocorrência lançada na leitura e baixa de boletos via arquivo retorno CNAB",
  },
  {
    chave: "OCORRENCIA_INCLUSAO_MANUAL_DEVEDOR",
    descricao: "Inclusão Manual de Devedor / Ficha",
    defaultText:
      "Ocorrência lançada quando um novo devedor / ficha é cadastrado manualmente no sistema",
  },
  {
    chave: "OCORRENCIA_INCLUSAO_MANUAL_CONTRATO",
    descricao: "Inclusão Manual de Contrato / Dívida",
    defaultText:
      "Ocorrência lançada quando um novo contrato / débito é cadastrado manualmente",
  },
  {
    chave: "OCORRENCIA_CRIACAO_HONORARIOS",
    descricao: "Cadastro de Honorários Avulsos",
    defaultText:
      "Ocorrência lançada na criação de ficha e débito de honorários avulsos (inclusive terceiros)",
  },
];

// Valores dos parâmetros (valor e tipo de ocorrência) em texto, na ordem da chave: igual = nada a salvar
const retratoDosValores = (mapa) => JSON.stringify(
  Object.keys(mapa || {}).sort().map((chave) => [chave, mapa[chave]?.valor ?? "", mapa[chave]?.tipoOcorrenciaId ?? null])
);

export default function ParametrizacaoSistema() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [currentTab, setCurrentTab] = useState(0);
  const [ocorrenciasList, setOcorrenciasList] = useState([]);
  const [parametros, setParametros] = useState({});
  // O que está gravado no banco (só os valores): a tela compara para avisar de alteração não salva
  const [parametrosGravados, setParametrosGravados] = useState(null);
  const alteracoesNaoSalvas = parametrosGravados !== null && retratoDosValores(parametros) !== parametrosGravados;
  const [folderStatus, setFolderStatus] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testingAll, setTestingAll] = useState(false);

  const [equipesList, setEquipesList] = useState([]);
  const [equipesMap, setEquipesMap] = useState({});

  const [auditModalOpen, setAuditModalOpen] = useState(false);
  const [auditTitle, setAuditTitle] = useState("");
  const [auditLogs, setAuditLogs] = useState([]);
  const [loadingAudit, setLoadingAudit] = useState(false);

  const handleOpenAuditoriaGeral = () => {
    setAuditTitle("Histórico de Auditoria - Parâmetros do Sistema");
    setAuditModalOpen(true);
    setLoadingAudit(true);
    get("/parametro-sistema/historico-geral")
      .then((res) => setAuditLogs(Array.isArray(res) ? res : []))
      .catch((err) => {
        console.error("Erro ao carregar auditoria de parâmetros:", err);
        setAuditLogs([]);
      })
      .finally(() => setLoadingAudit(false));
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [resOcorrencias, resParametros, resEquipes] = await Promise.all([
        get("/tipo-ocorrencia/list-all").catch(() =>
          post("/tipo-ocorrencia/list", { pageSize: 500, page: 0 })
        ),
        get("/parametro-sistema/list").catch(() => []),
        get("/equipe/list-all").catch(() => []),
      ]);

      const listOcorrencias = Array.isArray(resOcorrencias)
        ? resOcorrencias
        : resOcorrencias?.data || resOcorrencias?.list || [];
      const apenasSistema = listOcorrencias.filter(
        (o) =>
          o.categoria === 5 ||
          o.categoriaLabel === "Sistema" ||
          o.categoria === 2 ||
          o.categoria === 3 ||
          o.categoria === 4
      );
      const listaFinal = (
        apenasSistema.length > 0 ? apenasSistema : listOcorrencias
      ).slice();
      listaFinal.sort((a, b) => {
        const nomeA = (a.nome || a.ccNome || "").toLowerCase();
        const nomeB = (b.nome || b.ccNome || "").toLowerCase();
        return nomeA.localeCompare(nomeB, "pt-BR");
      });
      setOcorrenciasList(listaFinal);

      const listParametros = Array.isArray(resParametros)
        ? resParametros
        : resParametros?.data || resParametros?.list || [];
      const paramMap = {};
      listParametros.forEach((p) => {
        paramMap[p.chave] = p;
      });

      const rawEquipes = Array.isArray(resEquipes)
        ? resEquipes
        : resEquipes?.data || resEquipes?.list || [];
      setEquipesList(rawEquipes);

      let loadedMap = {};
      try {
        const jsonVal = paramMap["ROBO_EQUIPES_MAP_ID"]?.valor;
        if (jsonVal) {
          loadedMap = typeof jsonVal === "string" ? JSON.parse(jsonVal) : jsonVal;
        }
      } catch (e) {
        loadedMap = {};
      }

      // Auto-match inicial se o mapa estiver vazio
      if (Object.keys(loadedMap).length === 0 && rawEquipes.length > 0) {
        EQUIPES_WIBS.forEach((item) => {
          const matched = rawEquipes.find((eq) => {
            const eqNome = (eq.nome || "").toLowerCase().trim();
            const ch = item.chave.toLowerCase().trim();
            const chSemRal = ch.replace("ral-", "").trim();
            return eqNome === ch || eqNome === chSemRal || eqNome.includes(chSemRal);
          });
          if (matched) {
            loadedMap[item.chave] = matched.id;
          }
        });
      }
      setEquipesMap(loadedMap);

      PASTAS_SISTEMA.forEach((pasta) => {
        if (!paramMap[pasta.chave]) {
          paramMap[pasta.chave] = {
            chave: pasta.chave,
            descricao: pasta.descricao,
            valor: "",
          };
        } else if (paramMap[pasta.chave].valor === null || paramMap[pasta.chave].valor === undefined) {
          paramMap[pasta.chave].valor = "";
        }
      });

      // Inicializar Regras de Processamento
      REGRAS_PROCESSAMENTO.forEach((item) => {
        if (!paramMap[item.chave]) {
          paramMap[item.chave] = {
            chave: item.chave,
            descricao: item.descricao,
            valor: item.defaultVal,
          };
        } else if (paramMap[item.chave].valor === null || paramMap[item.chave].valor === undefined || paramMap[item.chave].valor === "") {
          paramMap[item.chave].valor = item.defaultVal;
        }
      });

      // Inicializar E-mails dos Robôs
      PARAMETROS_EMAILS_ROBOS.forEach((item) => {
        if (!paramMap[item.chave]) {
          paramMap[item.chave] = {
            chave: item.chave,
            descricao: item.label,
            valor: "",
          };
        } else if (paramMap[item.chave].valor === null || paramMap[item.chave].valor === undefined) {
          paramMap[item.chave].valor = "";
        }
      });

      // Inicializar Mapeamento de Equipes
      if (!paramMap["ROBO_EQUIPES_MAP_ID"]) {
        paramMap["ROBO_EQUIPES_MAP_ID"] = {
          chave: "ROBO_EQUIPES_MAP_ID",
          descricao: "Mapeamento JSON entre nomes dos grupos Wibs e os IDs das equipes no sistema",
          valor: JSON.stringify(loadedMap),
        };
      } else if (!paramMap["ROBO_EQUIPES_MAP_ID"].valor || paramMap["ROBO_EQUIPES_MAP_ID"].valor === "{}" || paramMap["ROBO_EQUIPES_MAP_ID"].valor === "") {
        paramMap["ROBO_EQUIPES_MAP_ID"].valor = JSON.stringify(loadedMap);
      }

      // Inicializar Status de Execução dos Robôs
      ROBOS_STATUS.forEach((robo) => {
        if (!paramMap[robo.chave]) {
          paramMap[robo.chave] = {
            chave: robo.chave,
            descricao: robo.descricao,
            valor: robo.defaultVal || "false",
          };
        } else if (paramMap[robo.chave].valor === null || paramMap[robo.chave].valor === undefined) {
          paramMap[robo.chave].valor = robo.defaultVal || "false";
        }
      });

      // Inicializar Pastas e Configurações dos Robôs
      PASTAS_E_CONFIG_ROBOS.forEach((item) => {
        if (!paramMap[item.chave]) {
          paramMap[item.chave] = {
            chave: item.chave,
            descricao: item.descricao,
            valor: item.defaultPath || "",
          };
        } else if (paramMap[item.chave].valor === null || paramMap[item.chave].valor === undefined) {
          paramMap[item.chave].valor = "";
        }
      });

      setParametros(paramMap);
      setParametrosGravados(retratoDosValores(paramMap));
    } catch (err) {
      console.error("Erro ao carregar parametrização:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handlePathChange = (chave, newPath) => {
    setParametros((prev) => ({
      ...prev,
      [chave]: {
        ...prev[chave],
        chave,
        valor: newPath,
      },
    }));
    setFolderStatus((prev) => ({
      ...prev,
      [chave]: null,
    }));
  };

  const handleEquipeMapChange = (wibsChave, equipeId) => {
    const newMap = { ...equipesMap, [wibsChave]: equipeId };
    setEquipesMap(newMap);
    handlePathChange("ROBO_EQUIPES_MAP_ID", JSON.stringify(newMap));
  };

  const handleToggleRobo = (chave, descricao) => {
    setParametros((prev) => {
      const currentVal = (prev[chave]?.valor || "").toLowerCase();
      const isCurrentlyActive = currentVal === "true" || currentVal === "1";
      const newVal = isCurrentlyActive ? "false" : "true";
      return {
        ...prev,
        [chave]: {
          ...prev[chave],
          chave,
          descricao,
          valor: newVal,
        },
      };
    });
  };

  const handleSelectOcorrencia = (chave, descricao, selectedOption) => {
    setParametros((prev) => ({
      ...prev,
      [chave]: {
        ...prev[chave],
        chave,
        descricao,
        tipoOcorrenciaId: selectedOption
          ? selectedOption.id || selectedOption.cvId
          : null,
        tipoOcorrenciaNome: selectedOption
          ? selectedOption.nome || selectedOption.ccNome
          : null,
      },
    }));
  };

  const handleTestSingleFolder = async (chave) => {
    const path = parametros[chave]?.valor?.trim();
    if (!path) {
      errorAlert("Informe o caminho da pasta antes de testar.");
      return;
    }
    try {
      const res = await post("/parametro-sistema/test-path", { path });
      setFolderStatus((prev) => ({
        ...prev,
        [chave]: res?.ok || res?.status === "OK" ? "OK" : "Erro",
      }));
    } catch (e) {
      setFolderStatus((prev) => ({ ...prev, [chave]: "Erro" }));
    }
  };

  const handleTestAllFolders = async () => {
    setTestingAll(true);
    try {
      const activeList =
        currentTab === 3
          ? PASTAS_E_CONFIG_ROBOS.filter((p) => p.isFolder)
          : PASTAS_SISTEMA;
      const pathsToTest = activeList
        .map((p) => (parametros[p.chave]?.valor || "").trim())
        .filter(Boolean);

      if (pathsToTest.length === 0) {
        setTestingAll(false);
        errorAlert("Nenhum caminho de pasta configurado para testar.");
        return;
      }

      const res = await post("/parametro-sistema/test-all-paths", pathsToTest);
      const newStatus = { ...folderStatus };
      activeList.forEach((p) => {
        const path = (parametros[p.chave]?.valor || "").trim();
        if (!path) {
          newStatus[p.chave] = null;
        } else {
          const st = res?.[path] || (res?.data && res.data[path]);
          newStatus[p.chave] = st === "OK" ? "OK" : "Erro";
        }
      });
      setFolderStatus(newStatus);
      successAlert(
        "Teste de permissão e existência das pastas concluído com sucesso!"
      );
    } catch (e) {
      errorAlert("Falha ao testar as pastas.");
    } finally {
      setTestingAll(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    const salvamentos = [];
    try {
      // Salvar Pastas do Sistema
      PASTAS_SISTEMA.forEach((pasta) => {
        const param = parametros[pasta.chave];
        if (param) {
          salvamentos.push(postNoResponse("/parametro-sistema/save", {
            id: param.id || null,
            chave: pasta.chave,
            descricao: pasta.descricao,
            valor: param.valor !== undefined && param.valor !== null ? param.valor : "",
          }));
        }
      });

      // Salvar Regras de Processamento (número inteiro >= mínimo; inválido volta para o padrão)
      REGRAS_PROCESSAMENTO.forEach((item) => {
        const param = parametros[item.chave];
        if (param) {
          const numero = parseInt(String(param.valor ?? "").trim(), 10);
          salvamentos.push(postNoResponse("/parametro-sistema/save", {
            id: param.id || null,
            chave: item.chave,
            descricao: item.descricao,
            valor: Number.isFinite(numero) && numero >= item.minimo ? String(numero) : item.defaultVal,
          }));
        }
      });

      // Salvar Parâmetros de E-mails dos Robôs
      PARAMETROS_EMAILS_ROBOS.forEach((paramItem) => {
        const paramEmail = parametros[paramItem.chave];
        if (paramEmail) {
          salvamentos.push(postNoResponse("/parametro-sistema/save", {
            id: paramEmail.id || null,
            chave: paramItem.chave,
            descricao: paramItem.label,
            valor: paramEmail.valor !== undefined && paramEmail.valor !== null ? paramEmail.valor : "",
          }));
        }
      });

      // Salvar Mapeamento de Equipes (Wibs ➔ Equipe do Sistema)
      const paramMapEquipes = parametros["ROBO_EQUIPES_MAP_ID"];
      salvamentos.push(postNoResponse("/parametro-sistema/save", {
        id: paramMapEquipes?.id || null,
        chave: "ROBO_EQUIPES_MAP_ID",
        descricao: paramMapEquipes?.descricao || "Mapeamento JSON entre nomes dos grupos Wibs e os IDs das equipes no sistema",
        valor: JSON.stringify(equipesMap),
      }));

      // Salvar Status de Execução dos Robôs
      ROBOS_STATUS.forEach((robo) => {
        const param = parametros[robo.chave];
        if (param) {
          salvamentos.push(postNoResponse("/parametro-sistema/save", {
            id: param.id || null,
            chave: robo.chave,
            descricao: robo.descricao,
            valor: param.valor !== undefined && param.valor !== null ? param.valor : (robo.defaultVal || "false"),
          }));
        }
      });

      // Salvar Pastas e Configurações dos Robôs
      PASTAS_E_CONFIG_ROBOS.forEach((item) => {
        const param = parametros[item.chave];
        if (param) {
          salvamentos.push(postNoResponse("/parametro-sistema/save", {
            id: param.id || null,
            chave: item.chave,
            descricao: item.descricao,
            valor: param.valor !== undefined && param.valor !== null ? param.valor : "",
          }));
        }
      });

      // Salvar Processos do Sistema
      PROCESSOS_SISTEMA.forEach((item) => {
        const param = parametros[item.chave];
        if (param) {
          salvamentos.push(postNoResponse("/parametro-sistema/save", {
            id: param.id || null,
            chave: item.chave,
            descricao: item.descricao,
            tipoOcorrenciaId: param.tipoOcorrenciaId || null,
          }));
        }
      });

      await Promise.all(salvamentos);

      successAlert("Parametrização do Sistema salva com sucesso!", () =>
        loadData()
      );
    } catch (err) {
      errorAlert("Erro ao salvar a parametrização do sistema.");
    } finally {
      setSaving(false);
    }
  };

  const [migrating, setMigrating] = useState(false);

  const handleMigrarArquivosAntigos = () => {
    setMigrating(true);
    postNoResponse("/parametro-sistema/migrar-documentos-antigos", {})
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const dev = data.devedores || {};
          const pen = data.penhorasProcessos || {};
          const msg = `Organização Concluída!\n\nAnexos de Fichas:\n- Movidos: ${dev.movidos || 0}\n- Já organizados: ${dev.jaOrganizados || 0}\n- Não encontrados: ${dev.naoEncontrados || 0}\n\nAnexos de Processos:\n- Movidos: ${pen.movidos || 0}\n- Já organizados: ${pen.jaOrganizados || 0}`;
          successAlert(msg);
        } else {
          errorAlert(data.error || "Erro ao organizar documentos antigos.");
        }
      })
      .catch((err) => {
        console.error(err);
        errorAlert("Erro ao tentar organizar os documentos antigos.");
      })
      .finally(() => {
        setMigrating(false);
      });
  };

  const [fixingPhoneDdd, setFixingPhoneDdd] = useState(false);

  const handleCorrigirDddTelefones = () => {
    setFixingPhoneDdd(true);
    postNoResponse("/parametro-sistema/corrigir-telefones-ddd", {})
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const msg = `Correção de DDDs Concluída!\n\n- Total de Telefones Corrigidos: ${data.totalCorrigidos || 0}\n- DDDs extraídos do número (10/11 dígitos): ${data.dddExtraidosDoTelefone || 0}\n- DDDs herdados de outro telefone do mesmo devedor: ${data.dddHerdadosMesmoDevedor || 0}`;
          successAlert(msg);
        } else {
          errorAlert(data.error || "Erro ao corrigir DDDs dos telefones.");
        }
      })
      .catch((err) => {
        console.error(err);
        errorAlert("Erro ao tentar corrigir os DDDs dos telefones.");
      })
      .finally(() => {
        setFixingPhoneDdd(false);
      });
  };

  if (loading) {
    return (
      <Card sx={{ background: darkMode ? ESCURO.cartao : "#fafafa", p: 5, display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
        <CircularProgress color="info" />
      </Card>
    );
  }

  return (
    <Card sx={{ background: darkMode ? ESCURO.cartao : "#fafafa", p: 2 }}>
      {/* Navigation Tabs + Action Buttons Bar */}
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
        borderBottom={1}
        borderColor="divider"
        flexWrap="wrap"
        gap={1}
      >
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{
            minHeight: "unset",
            pb: 1,
            "& .MuiTabs-indicator": {
              display: "none",
            },
            "& .MuiTabs-flexContainer": {
              gap: 1.5,
              flexWrap: "wrap",
            },
            "& .MuiTab-root": {
              minHeight: "42px",
              py: 1,
              px: 2.2,
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "0.85rem",
              fontWeight: 600,
              display: "inline-flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
              transition: "all 0.2s ease-in-out",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.2)"
                : "1px solid #d2d6dc",
              backgroundColor: darkMode
                ? "rgba(255, 255, 255, 0.05)"
                : "#ffffff",
              color: darkMode ? "rgba(255, 255, 255, 0.85)" : "#4b5563",
              "&:hover": {
                backgroundColor: darkMode
                  ? "rgba(255, 255, 255, 0.12)"
                  : "#f3f4f6",
                borderColor: darkMode
                  ? "rgba(255, 255, 255, 0.38)"
                  : "#9ca3af",
                color: darkMode ? "#ffffff" : "#111827",
              },
            },
            "& .Mui-selected": {
              backgroundColor: darkMode ? "#1976d2 !important" : "#1A73E8 !important",
              borderColor: darkMode ? "#1976d2 !important" : "#1A73E8 !important",
              color: "#ffffff !important",
              boxShadow: darkMode
                ? "0 4px 12px rgba(25, 118, 210, 0.45)"
                : "0 4px 10px rgba(26, 115, 232, 0.3)",
              "& .MuiIcon-root": {
                color: "#ffffff !important",
              },
            },
          }}
        >
          <Tab
            icon={
              <Icon fontSize="small" sx={{ mr: 0.5 }}>
                folder
              </Icon>
            }
            iconPosition="start"
            label="Pastas e Arquivos"
          />
          <Tab
            icon={
              <Icon fontSize="small" sx={{ mr: 0.5 }}>
                assignment
              </Icon>
            }
            iconPosition="start"
            label="Ocorrências de Cobrança"
          />
          <Tab
            icon={
              <Icon fontSize="small" sx={{ mr: 0.5 }}>
                settings
              </Icon>
            }
            iconPosition="start"
            label="Regras de Processamento"
          />
          <Tab
            icon={
              <Icon fontSize="small" sx={{ mr: 0.5 }}>
                smart_toy
              </Icon>
            }
            iconPosition="start"
            label="Robôs"
          />
        </Tabs>

        <MDBox display="flex" gap={1} pb={1} flexWrap="wrap">
          {currentTab === 0 && (
            <MDButton
              variant="outlined"
              color="warning"
              size="small"
              onClick={handleMigrarArquivosAntigos}
              disabled={migrating}
              sx={{ color: darkMode ? "#FFB74D !important" : "inherit" }}
            >
              <Icon sx={{ mr: 1 }}>folder_zip</Icon>{" "}
              {migrating ? "Organizando..." : "Organizar Anexos Antigos"}
            </MDButton>
          )}

          {(currentTab === 0 || currentTab === 3) && (
            <MDButton
              variant="outlined"
              color="info"
              size="small"
              onClick={handleTestAllFolders}
              disabled={testingAll}
              sx={{
                color: darkMode ? "#64B5F6 !important" : "inherit",
                borderColor: darkMode ? "rgba(100, 181, 246, 0.5) !important" : undefined,
              }}
            >
              <Icon sx={{ mr: 1 }}>sync</Icon> Testar Todas as Pastas
            </MDButton>
          )}

          <MDButton
            variant="outlined"
            color="info"
            size="small"
            onClick={handleCorrigirDddTelefones}
            disabled={fixingPhoneDdd}
            sx={{
              color: darkMode ? "#64B5F6 !important" : "inherit",
              borderColor: darkMode ? "rgba(100, 181, 246, 0.5) !important" : undefined,
            }}
          >
            <Icon sx={{ mr: 1 }}>phone_in_talk</Icon>{" "}
            {fixingPhoneDdd ? "Corrigindo..." : "Corrigir DDDs dos Telefones"}
          </MDButton>

          <MDButton
            variant="contained"
            color="info"
            size="small"
            onClick={handleSave}
            disabled={saving}
            sx={{
              backgroundColor: darkMode ? "#007bff !important" : undefined,
              color: "#ffffff !important",
              fontWeight: "bold",
              boxShadow: darkMode ? "0 4px 10px rgba(0, 123, 255, 0.3)" : undefined,
              "&:hover": {
                backgroundColor: darkMode ? "#0069d9 !important" : undefined,
              },
            }}
          >
            <Icon sx={{ mr: 1 }}>save</Icon> Salvar Configurações{alteracoesNaoSalvas ? " *" : ""}
          </MDButton>

          <MDButton
            variant="outlined"
            color="info"
            size="small"
            onClick={handleOpenAuditoriaGeral}
          >
            <Icon sx={{ mr: 1 }}>history</Icon> Auditoria de Parâmetros
          </MDButton>
        </MDBox>
      </MDBox>

      {alteracoesNaoSalvas && (
        <Alert severity="warning" sx={{ mb: 2, fontSize: "0.85rem" }}>
          Há alterações não salvas. Elas só passam a valer (inclusive para os robôs, que leem o que está gravado) depois
          de clicar em <strong>Salvar Configurações</strong>.
        </Alert>
      )}

      {/* TAB 0: PASTAS E ARQUIVOS */}
      {currentTab === 0 && (
        <MDBox
          sx={{
            background: darkMode
              ? `linear-gradient(145deg, ${ESCURO.hover} 0%, ${ESCURO.campo} 100%)`
              : "#fff",
            borderRadius: 2,
            p: 3,
          }}
        >

          <TableContainer sx={{ boxShadow: "none" }}>
            <Table sx={{ width: "100%", tableLayout: "fixed" }}>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <DataTableHeadCell width="22%" sorted={false}>
                    Descrição
                  </DataTableHeadCell>
                  <DataTableHeadCell width="28%" sorted={false}>
                    Finalidade
                  </DataTableHeadCell>
                  <DataTableHeadCell width="34%" sorted={false}>
                    Caminho da Pasta
                  </DataTableHeadCell>
                  <DataTableHeadCell width="8%" align="center" sorted={false}>
                    Status
                  </DataTableHeadCell>
                  <DataTableHeadCell width="8%" align="center" sorted={false}>
                    Ações
                  </DataTableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {PASTAS_SISTEMA.map((item) => {
                  const currentPath =
                    parametros[item.chave]?.valor !== undefined && parametros[item.chave]?.valor !== null
                      ? parametros[item.chave].valor
                      : "";
                  const st = folderStatus[item.chave];

                  return (
                    <TableRow key={item.chave}>
                      <TableCell
                        sx={{
                          width: "22%",
                          verticalAlign: "middle",
                          py: 1.5,
                          color: darkMode ? "#fff" : "inherit",
                        }}
                      >
                        <MDBox display="flex" alignItems="center" gap={1}>
                          <Icon color={item.color}>{item.icon}</Icon>
                          <MDTypography
                            variant="button"
                            fontWeight="medium"
                            color={darkMode ? "white" : "dark"}
                          >
                            {item.descricao}
                          </MDTypography>
                        </MDBox>
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "28%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDTypography variant="caption" color="text">
                          {item.finalidade}
                        </MDTypography>
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "34%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDInput
                          fullWidth
                          size="small"
                          value={currentPath}
                          onChange={(e) =>
                            handlePathChange(item.chave, e.target.value)
                          }
                          placeholder={item.defaultPath ? `Ex: ${item.defaultPath}` : "Informe o caminho da pasta..."}
                         
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "8%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        {st === "OK" && (
                          <Chip
                            label="OK"
                            color="success"
                            size="small"
                            sx={{ fontWeight: "bold", color: "#fff" }}
                          />
                        )}
                        {st === "Erro" && (
                          <Chip
                            label="Erro"
                            color="error"
                            size="small"
                            sx={{ fontWeight: "bold", color: "#fff" }}
                          />
                        )}
                        {!st && (
                          <Chip
                            label="Pendente"
                            size="small"
                            variant="outlined"
                            sx={{
                              color: darkMode ? "#bbb" : "#666",
                              borderColor: darkMode ? ESCURO.borda : "#ccc",
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          width: "8%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDButton
                          variant="text"
                          color="info"
                          size="small"
                          onClick={() => handleTestSingleFolder(item.chave)}
                        >
                          <Icon sx={{ mr: 0.5 }}>play_arrow</Icon> Testar
                        </MDButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Dica de permissões */}
          <MDBox
            mt={3}
            p={2}
            borderRadius={2}
            sx={{
              background: darkMode
                ? "rgba(255,255,255,0.05)"
                : "rgba(26,115,232,0.05)",
              border: darkMode
                ? "1px solid rgba(255,255,255,0.1)"
                : "1px solid rgba(26,115,232,0.2)",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Icon color="info">info</Icon>
            <MDTypography variant="button" color={darkMode ? "white" : "info"}>
              <strong>Dica:</strong> Certifique-se de que o usuário do serviço
              do sistema possui permissão de leitura e gravação nas pastas
              configuradas.
            </MDTypography>
          </MDBox>
        </MDBox>
      )}

      {/* TAB 1: OCORRÊNCIAS DE COBRANÇA */}
      {currentTab === 1 && (
        <MDBox
          sx={{
            background: darkMode
              ? `linear-gradient(145deg, ${ESCURO.hover} 0%, ${ESCURO.campo} 100%)`
              : "#fff",
            borderRadius: 2,
            p: 3,
          }}
        >
          <TableContainer sx={{ boxShadow: "none" }}>
            <Table sx={{ width: "100%", tableLayout: "fixed" }}>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <DataTableHeadCell width="45%" sorted={false}>
                    Processo do Sistema
                  </DataTableHeadCell>
                  <DataTableHeadCell width="35%" sorted={false}>
                    Ocorrência Vinculada
                  </DataTableHeadCell>
                  <DataTableHeadCell width="20%" sorted={false}>
                    Situação Gerada
                  </DataTableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {PROCESSOS_SISTEMA.map((item) => {
                  const currentParam = parametros[item.chave] || {};
                  const currentOcorrencia =
                    ocorrenciasList.find(
                      (o) => (o.id || o.cvId) === currentParam.tipoOcorrenciaId
                    ) || null;

                  return (
                    <TableRow key={item.chave}>
                      <TableCell
                        sx={{
                          width: "45%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDTypography
                          variant="button"
                          fontWeight="medium"
                          color={darkMode ? "white" : "dark"}
                        >
                          {item.descricao}
                        </MDTypography>
                        <MDTypography
                          variant="caption"
                          color="text"
                          display="block"
                        >
                          {item.defaultText}
                        </MDTypography>
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "35%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <Autocomplete
                          fullWidth
                          options={ocorrenciasList}
                          getOptionLabel={(option) =>
                            option.nome || option.ccNome || ""
                          }
                          value={currentOcorrencia}
                          onChange={(e, newValue) =>
                            handleSelectOcorrencia(
                              item.chave,
                              item.descricao,
                              newValue
                            )
                          }
                          renderInput={(params) => (
                            <MDInput
                              {...params}
                              label="Selecione a Ocorrência..."
                              variant="standard"
                              fullWidth
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            (option.id || option.cvId) ===
                            (value?.id || value?.cvId)
                          }
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          width: "20%",
                          verticalAlign: "middle",
                          py: 1.5,
                        }}
                      >
                        <MDTypography
                          variant="button"
                          fontWeight="bold"
                          color={
                            currentOcorrencia?.situacaoFichaLabel
                              ? "info"
                              : "text"
                          }
                        >
                          {currentOcorrencia?.situacaoFichaLabel || "Nenhuma"}
                        </MDTypography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      )}

      {/* TAB 2: REGRAS DE PROCESSAMENTO */}
      {currentTab === 2 && (
        <MDBox
          sx={{
            background: darkMode
              ? `linear-gradient(145deg, ${ESCURO.hover} 0%, ${ESCURO.campo} 100%)`
              : "#fff",
            borderRadius: 2,
            p: 3,
          }}
        >
          <TableContainer sx={{ boxShadow: "none" }}>
            <Table sx={{ width: "100%", tableLayout: "fixed" }}>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <DataTableHeadCell width="28%" sorted={false}>
                    Regra
                  </DataTableHeadCell>
                  <DataTableHeadCell width="50%" sorted={false}>
                    Finalidade
                  </DataTableHeadCell>
                  <DataTableHeadCell width="22%" sorted={false}>
                    Valor
                  </DataTableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {REGRAS_PROCESSAMENTO.map((item) => (
                  <TableRow key={item.chave}>
                    <TableCell sx={{ verticalAlign: "top", pt: 1.5 }}>
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon color={item.color}>{item.icon}</Icon>
                        <MDTypography variant="button" fontWeight="medium" color={darkMode ? "white" : "dark"}>
                          {item.descricao}
                        </MDTypography>
                      </MDBox>
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "top", pt: 1.5 }}>
                      <MDTypography variant="caption" color="text">
                        {item.finalidade}
                      </MDTypography>
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "top", pt: 1.5 }}>
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <MDInput
                          type="number"
                          size="small"
                          value={parametros[item.chave]?.valor ?? item.defaultVal}
                          onChange={(e) => handlePathChange(item.chave, e.target.value)}
                          inputProps={{ min: item.minimo, step: 1 }}
                          sx={{ width: 110 }}
                        />
                        <MDTypography variant="caption" color="text">{item.unidade}</MDTypography>
                      </MDBox>
                      <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 0.5, opacity: 0.8 }}>
                        Padrão: {item.defaultVal} {item.unidade}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      )}

      {/* TAB 3: ROBÔS */}
      {currentTab === 3 && (
        <MDBox
          sx={{
            background: darkMode
              ? `linear-gradient(145deg, ${ESCURO.hover} 0%, ${ESCURO.campo} 100%)`
              : "#fff",
            borderRadius: 2,
            p: 3,
          }}
        >
          {/* Card 1: E-mails dos Robôs (Globais e Teste) */}
          <MDBox
            sx={{
              p: 2.5,
              borderRadius: 2,
              background: darkMode ? ESCURO.painel : "#ffffff",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid #e0e0e0",
              mb: 3,
            }}
          >
            <MDBox display="flex" alignItems="center" gap={1.2} mb={1}>
              <Icon sx={{ color: "#FFA726", fontSize: "1.6rem !important" }}>
                mark_email_read
              </Icon>
              <MDTypography
                variant="h6"
                fontWeight="bold"
                color={darkMode ? "white" : "dark"}
              >
                E-mails dos Robôs (Globais e Teste)
              </MDTypography>
            </MDBox>
            <MDTypography variant="caption" color="text" display="block" mb={2}>
              Configure os e-mails gerais dos robôs. O <strong>E-mail de Teste</strong> intercepta todos os disparos em ambiente de desenvolvimento. Os e-mails de <strong>Não Localizados</strong>, <strong>Outros</strong> e <strong>Validação</strong> servem de fallback e relatórios de execução.
            </MDTypography>
            <Grid container spacing={2.5}>
              {PARAMETROS_EMAILS_ROBOS.map((item) => {
                const currentVal =
                  parametros[item.chave]?.valor !== undefined &&
                  parametros[item.chave]?.valor !== null
                    ? parametros[item.chave].valor
                    : "";
                return (
                  <Grid item xs={12} sm={item.sm || 6} key={item.chave}>
                    <MDBox display="flex" alignItems="center" gap={0.8} mb={0.5}>
                      <Icon sx={{ color: item.color, fontSize: "1.1rem !important" }}>
                        {item.icon}
                      </Icon>
                      <MDTypography
                        variant="button"
                        fontWeight="bold"
                        color={darkMode ? "white" : "dark"}
                      >
                        {item.label}
                      </MDTypography>
                    </MDBox>
                    <MDInput
                      fullWidth
                      size="small"
                      value={currentVal}
                      onChange={(e) => handlePathChange(item.chave, e.target.value)}
                      placeholder={item.placeholder}
                     
                    />
                    <MDTypography variant="caption" color="text" display="block" mt={0.3} sx={{ fontSize: "0.72rem" }}>
                      {item.detalhe}
                    </MDTypography>
                  </Grid>
                );
              })}
            </Grid>
          </MDBox>

          {/* Card 2: Habilitação dos Robôs */}
          <MDBox
            sx={{
              p: 2.5,
              borderRadius: 2,
              background: darkMode ? ESCURO.painel : "#ffffff",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid #e0e0e0",
              mb: 3,
            }}
          >
            <MDBox display="flex" alignItems="center" gap={1.2} mb={1}>
              <Icon sx={{ color: "#4caf50", fontSize: "1.6rem !important" }}>
                power_settings_new
              </Icon>
              <MDTypography
                variant="h6"
                fontWeight="bold"
                color={darkMode ? "white" : "dark"}
              >
                Habilitação dos Robôs
              </MDTypography>
            </MDBox>
            <MDTypography variant="caption" color="text" display="block" mb={2.5}>
              Habilite ou desabilite a execução agendada de cada robô através dos
              botões abaixo. Clique no botão para alternar entre Ativo e Inativo e depois em
              Salvar Configurações: o robô passa a obedecer na próxima rodada.
            </MDTypography>

            <Grid container spacing={2}>
              {ROBOS_STATUS.map((robo) => {
                const val = (
                  parametros[robo.chave]?.valor ||
                  robo.defaultVal ||
                  "false"
                ).toLowerCase();
                const isAtivo = val === "true" || val === "1";

                return (
                  <Grid item xs={12} sm={6} md={4} key={robo.chave}>
                    <MDBox
                      sx={{
                        p: 1.8,
                        borderRadius: 2,
                        background: darkMode ? ESCURO.painelEscuro : "#f8f9fa",
                        border: darkMode
                          ? isAtivo
                            ? "1px solid rgba(76, 175, 80, 0.45)"
                            : "1px solid rgba(255, 255, 255, 0.08)"
                          : isAtivo
                          ? "1px solid rgba(76, 175, 80, 0.5)"
                          : "1px solid #e9ecef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1.5,
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                          borderColor: isAtivo
                            ? "#4caf50"
                            : darkMode
                            ? "rgba(255, 255, 255, 0.2)"
                            : "#ccc",
                        },
                      }}
                    >
                      <MDBox
                        display="flex"
                        alignItems="flex-start"
                        gap={1}
                        sx={{ minWidth: 0, flex: 1 }}
                      >
                        <Icon
                          sx={{
                            color: isAtivo
                              ? "#4caf50"
                              : darkMode
                              ? ESCURO.textoFraco
                              : "#9e9e9e",
                            fontSize: "1.4rem !important",
                            mt: 0.2,
                            filter: isAtivo
                              ? "drop-shadow(0 0 3px rgba(76, 175, 80, 0.5))"
                              : "none",
                            transition: "all 0.2s",
                          }}
                        >
                          power_settings_new
                        </Icon>
                        <MDBox sx={{ minWidth: 0, flex: 1 }}>
                          <MDTypography
                            variant="button"
                            fontWeight="bold"
                            color={darkMode ? "white" : "dark"}
                            sx={{
                              display: "block",
                              lineHeight: 1.25,
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            {robo.nome}
                          </MDTypography>
                          <MDTypography
                            variant="caption"
                            color="text"
                            sx={{
                              display: "block",
                              lineHeight: 1.2,
                              mt: 0.4,
                              fontSize: "0.72rem",
                            }}
                          >
                            {robo.detalhe}
                          </MDTypography>
                        </MDBox>
                      </MDBox>

                      <MDButton
                        variant="contained"
                        color={isAtivo ? "success" : "secondary"}
                        size="small"
                        onClick={() =>
                          handleToggleRobo(robo.chave, robo.descricao)
                        }
                        sx={{
                          minWidth: "85px",
                          px: 1.5,
                          py: 0.6,
                          textTransform: "none",
                          fontWeight: "bold",
                          fontSize: "0.78rem",
                          backgroundColor: isAtivo
                            ? "#4caf50 !important"
                            : darkMode
                            ? `${ESCURO.campo} !important`
                            : "#e0e0e0 !important",
                          color: isAtivo
                            ? "#ffffff !important"
                            : darkMode
                            ? "#cccccc !important"
                            : "#666666 !important",
                          boxShadow: isAtivo
                            ? "0 2px 6px rgba(76, 175, 80, 0.4)"
                            : "none",
                          "&:hover": {
                            backgroundColor: isAtivo
                              ? "#43a047 !important"
                              : darkMode
                              ? `${ESCURO.hover} !important`
                              : "#d5d5d5 !important",
                          },
                        }}
                      >
                        <Icon sx={{ mr: 0.4, fontSize: "0.95rem !important" }}>
                          {isAtivo ? "check" : "power_settings_new"}
                        </Icon>
                        {isAtivo ? "Ativo" : "Inativo"}
                      </MDButton>
                    </MDBox>
                  </Grid>
                );
              })}
            </Grid>
          </MDBox>

          {/* Card 3: Pastas e Parâmetros dos Robôs */}
          <MDBox
            sx={{
              p: 2.5,
              borderRadius: 2,
              background: darkMode ? ESCURO.painel : "#ffffff",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid #e0e0e0",
            }}
          >
            <MDBox display="flex" alignItems="center" gap={1.2} mb={1}>
              <Icon sx={{ color: "#2196F3", fontSize: "1.6rem !important" }}>
                folder
              </Icon>
              <MDTypography
                variant="h6"
                fontWeight="bold"
                color={darkMode ? "white" : "dark"}
              >
                Pastas e Parâmetros dos Robôs
              </MDTypography>
            </MDBox>
            <MDTypography variant="caption" color="text" display="block" mb={2}>
              Diretórios de entrada, saída, histórico e parâmetros de execução
              dos robôs.
            </MDTypography>

            <TableContainer sx={{ boxShadow: "none" }}>
              <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                <TableHead sx={{ display: "table-header-group" }}>
                  <TableRow>
                    <DataTableHeadCell width="24%" sorted={false}>
                      Descrição
                    </DataTableHeadCell>
                    <DataTableHeadCell width="28%" sorted={false}>
                      Finalidade
                    </DataTableHeadCell>
                    <DataTableHeadCell width="32%" sorted={false}>
                      Caminho / Configuração
                    </DataTableHeadCell>
                    <DataTableHeadCell width="8%" align="center" sorted={false}>
                      Status
                    </DataTableHeadCell>
                    <DataTableHeadCell width="8%" align="center" sorted={false}>
                      Ações
                    </DataTableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {PASTAS_E_CONFIG_ROBOS.map((item) => {
                    const currentPath =
                      parametros[item.chave]?.valor !== undefined &&
                      parametros[item.chave]?.valor !== null
                        ? parametros[item.chave].valor
                        : "";
                    const st = folderStatus[item.chave];

                    return (
                      <TableRow key={item.chave}>
                        <TableCell
                          sx={{
                            width: "24%",
                            verticalAlign: "middle",
                            py: 1.5,
                            color: darkMode ? "#fff" : "inherit",
                          }}
                        >
                          <MDBox display="flex" alignItems="center" gap={1}>
                            <Icon color={item.color}>{item.icon}</Icon>
                            <MDTypography
                              variant="button"
                              fontWeight="medium"
                              color={darkMode ? "white" : "dark"}
                            >
                              {item.descricao}
                            </MDTypography>
                          </MDBox>
                        </TableCell>
                        <TableCell
                          sx={{
                            width: "28%",
                            verticalAlign: "middle",
                            py: 1.5,
                          }}
                        >
                          <MDTypography variant="caption" color="text">
                            {item.finalidade}
                          </MDTypography>
                        </TableCell>
                        <TableCell
                          sx={{
                            width: "32%",
                            verticalAlign: "middle",
                            py: 1.5,
                          }}
                        >
                          <MDInput
                            fullWidth
                            size="small"
                            value={currentPath}
                            onChange={(e) =>
                              handlePathChange(item.chave, e.target.value)
                            }
                            placeholder={
                              item.defaultPath || item.exemplo
                                ? `Ex: ${item.defaultPath || item.exemplo}`
                                : "Informe o valor..."
                            }
                           
                          />
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            width: "8%",
                            verticalAlign: "middle",
                            py: 1.5,
                          }}
                        >
                          {item.isFolder ? (
                            <>
                              {st === "OK" && (
                                <Chip
                                  label="OK"
                                  color="success"
                                  size="small"
                                  sx={{ fontWeight: "bold", color: "#fff" }}
                                />
                              )}
                              {st === "Erro" && (
                                <Chip
                                  label="Erro"
                                  color="error"
                                  size="small"
                                  sx={{ fontWeight: "bold", color: "#fff" }}
                                />
                              )}
                              {!st && (
                                <Chip
                                  label="Pendente"
                                  size="small"
                                  variant="outlined"
                                  sx={{
                                    color: darkMode ? "#bbb" : "#666",
                                    borderColor: darkMode ? ESCURO.borda : "#ccc",
                                  }}
                                />
                              )}
                            </>
                          ) : (
                            <Chip
                              label="Config"
                              size="small"
                              variant="outlined"
                              sx={{
                                color: darkMode ? "#90caf9" : "#1976d2",
                                borderColor: darkMode ? "#90caf9" : "#1976d2",
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            width: "8%",
                            verticalAlign: "middle",
                            py: 1.5,
                          }}
                        >
                          {item.isFolder ? (
                            <MDButton
                              variant="text"
                              color="info"
                              size="small"
                              onClick={() => handleTestSingleFolder(item.chave)}
                            >
                              <Icon sx={{ mr: 0.5 }}>play_arrow</Icon> Testar
                            </MDButton>
                          ) : (
                            <MDTypography variant="caption" color="text">
                              -
                            </MDTypography>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </MDBox>

          {/* Card 4: Mapeamento de Equipes dos Robôs */}
          <MDBox
            sx={{
              p: 2.5,
              borderRadius: 2,
              background: darkMode ? ESCURO.painel : "#ffffff",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid #e0e0e0",
              mt: 3,
            }}
          >
            <MDBox display="flex" alignItems="center" gap={1.2} mb={1}>
              <Icon sx={{ color: "#AB47BC", fontSize: "1.6rem !important" }}>
                hub
              </Icon>
              <MDTypography
                variant="h6"
                fontWeight="bold"
                color={darkMode ? "white" : "dark"}
              >
                Mapeamento de Equipes (Wibs / Arquivos ➔ Equipe do Sistema)
              </MDTypography>
            </MDBox>
            <MDTypography variant="caption" color="text" display="block" mb={2.5}>
              Vincule cada grupo retornado pelo Wibs à sua respectiva equipe cadastrada no sistema.
              Os robôs enviam para os <strong>e-mails da equipe mapeada</strong> (exibidos abaixo de cada grupo), mesmo que o nome da equipe mude no cadastro.
              <br />
              <strong>Para alterar os e-mails:</strong> acesse <strong>Ferramentas → Equipes</strong> e edite a equipe. Cada robô tem seu campo
              (Recortes, Edital, Push / Intimação e EPROC / T-Legal, que usam o mesmo campo); quando o campo do robô está vazio, vale o <strong>E-mail Geral da Equipe</strong>.
            </MDTypography>

            <Grid container spacing={2}>
              {EQUIPES_WIBS.map((item) => {
                const currentEquipeId = equipesMap[item.chave];
                const selectedEquipe =
                  equipesList.find(
                    (eq) => String(eq.id) === String(currentEquipeId)
                  ) || null;

                return (
                  <Grid item xs={12} sm={6} md={6} key={item.chave}>
                    <MDBox
                      sx={{
                        p: 1.8,
                        borderRadius: 2,
                        background: darkMode ? ESCURO.painelEscuro : "#f8f9fa",
                        border: darkMode
                          ? "1px solid rgba(255, 255, 255, 0.08)"
                          : "1px solid #e9ecef",
                      }}
                    >
                      <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                        <MDTypography
                          variant="button"
                          fontWeight="bold"
                          color={darkMode ? "white" : "dark"}
                        >
                          Grupo Wibs: {item.rotulo}
                        </MDTypography>
                        {selectedEquipe && (
                          <Chip
                            label="Mapeada"
                            size="small"
                            color="success"
                            sx={{ fontWeight: "bold", height: "20px" }}
                          />
                        )}
                      </MDBox>
                      <Autocomplete
                        options={equipesList}
                        getOptionLabel={(option) => option.nome || ""}
                        value={selectedEquipe}
                        onChange={(_, novoValor) =>
                          handleEquipeMapChange(
                            item.chave,
                            novoValor ? novoValor.id : null
                          )
                        }
                        isOptionEqualToValue={(option, value) =>
                          String(option?.id) === String(value?.id)
                        }
                        renderInput={(params) => (
                          <MDInput
                            {...params}
                            size="small"
                            placeholder="Selecione a equipe do sistema..."
                           
                          />
                        )}
                      />
                      {selectedEquipe && (
                        <MDBox mt={1}>
                          {/* Mesma regra do robô: e-mail específico do tipo; se vazio, o e-mail geral da equipe */}
                          {[
                            { rotulo: "Push / Intimação", especifico: selectedEquipe.emailPush },
                            { rotulo: "EPROC / T-Legal", especifico: selectedEquipe.emailEproc },
                            { rotulo: "Edital", especifico: selectedEquipe.emailEdital },
                            { rotulo: "Recortes", especifico: selectedEquipe.emailRecortes },
                          ].map(({ rotulo, especifico }) => {
                            const temEspecifico = !!(especifico && especifico.trim());
                            const efetivo = temEspecifico ? especifico : selectedEquipe.email;
                            return (
                              <MDTypography
                                key={rotulo}
                                variant="caption"
                                color="text"
                                display="block"
                                sx={{ wordBreak: "break-word", lineHeight: 1.5 }}
                              >
                                <strong>{rotulo}:</strong>{" "}
                                {efetivo && efetivo.trim() ? (
                                  <>
                                    {efetivo}
                                    {!temEspecifico && <i> (e-mail geral da equipe)</i>}
                                  </>
                                ) : (
                                  <span style={{ color: "#f44335" }}>sem e-mail na equipe (envia para o e-mail &quot;Outros&quot;)</span>
                                )}
                              </MDTypography>
                            );
                          })}
                        </MDBox>
                      )}
                    </MDBox>
                  </Grid>
                );
              })}
            </Grid>
          </MDBox>
        </MDBox>
      )}

      <MDAuditModal
        open={auditModalOpen}
        onClose={() => setAuditModalOpen(false)}
        title={auditTitle}
        loading={loadingAudit}
        logs={auditLogs}
        entityLabel="Parâmetro"
      />
    </Card>
  );
}
